'use strict';
import template from './corteMensual.html';
import controller from './corteMensual.controller';

const CorteMensualComponent = {
  controller,
  template
};

export default CorteMensualComponent;


// WEBPACK FOOTER //
// ./src/app/components/operaciones/corteMensual/corteMensual.component.js